import moment from "moment-timezone";
import AdminBadge from "../_components/AdminBadge";
import { cellClass, stickyCellClass } from "../_components/AdminTable";
import AdminRowActions, { ViewLink } from "../_components/AdminRowActions";

const getPaymentStatus = (paymentStatus, refundStatus) => {
  if (paymentStatus === "NO_NEED_CHARGE" && refundStatus === "NO_NEED_REFUND") {
    return { text: "No price changes", tone: "success" };
  }
  if (paymentStatus === "CHARGE_PENDING") return { text: "Charge Pending", tone: "warning" };
  if (refundStatus === "REFUND_PENDING") return { text: "Refund Pending", tone: "warning" };
  if (paymentStatus === "CHARGED") return { text: "Charged", tone: "success" };
  if (refundStatus === "REFUNDED") return { text: "Refunded", tone: "success" };
  return { text: "-", tone: "neutral" };
};

const APPROVAL_STATUS = {
  PENDING_APPROVAL: { text: "Pending Approval", tone: "warning" },
  APPROVED: { text: "Approved", tone: "success" },
  REJECTED: { text: "Rejected", tone: "danger" },
};

const getApprovalStatus = (status) => APPROVAL_STATUS[status] || { text: "-", tone: "neutral" };

const formatDate = (value, format = "YYYY/MM/DD") =>
  value ? moment(value).locale("en").format(format) : "-";

const CancelRescheduleRequestItem = ({ cancelreschedulerequest, count }) => {
  const payment = getPaymentStatus(
    cancelreschedulerequest.paymentStatus,
    cancelreschedulerequest.refundStatus,
  );
  const approval = getApprovalStatus(cancelreschedulerequest.status);
  const isReschedule = cancelreschedulerequest.requestType === "reschedule";

  return (
    <tr>
      <td className={cellClass}>{count + 1}</td>
      <td className={cellClass}>
        <div className="tw:flex tw:flex-col">
          <span className="tw:!text-[15px] tw:!text-[#282828] tw:leading-none tw:mb-1">
            {cancelreschedulerequest.userId?.name}
          </span>
          <span className="tw:!text-[13px] tw:!text-[#8D8D8D] tw:leading-none">
            {cancelreschedulerequest.userId?.role}
          </span>
        </div>
      </td>
      <td className={cellClass}>
        <AdminBadge tone={isReschedule ? "info" : "purple"}>
          {isReschedule ? "Edit Booking" : "Cancellation"}
        </AdminBadge>
      </td>
      <td className={`${cellClass} tw:whitespace-nowrap`}>
        {cancelreschedulerequest.date
          ? moment.tz(cancelreschedulerequest.date, "Asia/Tokyo").locale("en").format("YYYY/MM/DD HH:mm")
          : "-"}
      </td>
      <td className={`${cellClass} tw:whitespace-nowrap`}>
        {formatDate(cancelreschedulerequest?.bookingId?.travelDate)}
      </td>
      <td className={`${cellClass} tw:whitespace-nowrap`}>
        {formatDate(cancelreschedulerequest?.editBooking?.travelDate)}
      </td>
      <td className={cellClass}>
        <AdminBadge tone={payment.tone}>{payment.text}</AdminBadge>
      </td>
      <td className={cellClass}>
        <AdminBadge tone={approval.tone}>{approval.text}</AdminBadge>
      </td>
      <td className={cellClass}>{cancelreschedulerequest.responseBy?.name || "-"}</td>
      <td className={stickyCellClass}>
        <AdminRowActions>
          <ViewLink
            to={`/admin/cancel-reschedule-request/manage/${cancelreschedulerequest._id}`}
            label="Manage request"
          />
        </AdminRowActions>
      </td>
    </tr>
  );
};

export default CancelRescheduleRequestItem;
